import { render, staticRenderFns } from "./CursoDetalle.vue?vue&type=template&id=63f8fbca&"
import script from "./CursoDetalle.vue?vue&type=script&lang=js&"
export * from "./CursoDetalle.vue?vue&type=script&lang=js&"
import style0 from "./CursoDetalle.vue?vue&type=style&index=0&id=63f8fbca&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports